/**
 * Il segnale «i filtri dei pannelli relazione vanno rifatti».
 *
 * ## Perché serve
 *
 * `useRelationFilters` chiede al plugin quali id nascondere, e il plugin
 * risponde con una chiamata. Il core non ha modo di accorgersi che quel dato è
 * cambiato: quando il box Veterinari scollega qualcuno, la sua tabella cambia e
 * il pannello Contatti non lo sa. Il sintomo è preciso e brutto — si toglie un
 * veterinario, e la persona non ricompare fra i contatti finché non si ricarica
 * la pagina.
 *
 * Le relazioni del core hanno già `onRelationChanged`; questo è il suo gemello
 * per i dati che stanno fuori dal core.
 *
 * ## Perché un bus e non lo store
 *
 * Perché gli id li possiede il plugin, non Redux: metterli nello store
 * vorrebbe dire che il core conosce la forma dei dati di ogni plugin. Qui
 * passa solo un «rileggi», e chi rilegge sa da dove.
 *
 * ## Come si usa
 *
 * Il plugin chiama `notifyRelationFiltersChanged()` dopo ogni scrittura che
 * cambia ciò che va nascosto. Dimenticarlo non rompe niente e non dà errore:
 * lascia un pannello indietro fino al prossimo caricamento — ed è il motivo per
 * cui sta scritto qui e non solo nel tipo.
 */

type Listener = () => void;

const listeners = new Set<Listener>();

/** Il plugin lo chiama dopo aver scritto. */
export function notifyRelationFiltersChanged(): void {
  // Copia prima di iterare: un listener che si disiscrive durante la notifica
  // modificherebbe il Set mentre lo si sta percorrendo.
  for (const l of [...listeners]) l();
}

/** Lo usa `useRelationFilters`. Ritorna la funzione per disiscriversi. */
export function subscribeRelationFilters(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
